/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FilterViewScope } from './FilterViewScope';
import {
    FilterViewScopeFromJSON,
    FilterViewScopeFromJSONTyped,
    FilterViewScopeToJSON,
    FilterViewScopeToJSONTyped,
} from './FilterViewScope';

/**
 * 
 * @export
 * @interface CreateFilterViewRequest
 */
export interface CreateFilterViewRequest {
    /**
     * 
     */
    scope: FilterViewScope;
    /**
     * 
     */
    view_key: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    filters: { [key: string]: any; };
    /**
     * 
     */
    is_default?: boolean;
}



/**
 * Check if a given object implements the CreateFilterViewRequest interface.
 */
export function instanceOfCreateFilterViewRequest(value: object): value is CreateFilterViewRequest {
    if (!('scope' in value) || value['scope'] === undefined) return false;
    if (!('view_key' in value) || value['view_key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('filters' in value) || value['filters'] === undefined) return false;
    return true;
}

export function CreateFilterViewRequestFromJSON(json: any): CreateFilterViewRequest {
    return CreateFilterViewRequestFromJSONTyped(json, false);
}

export function CreateFilterViewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFilterViewRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'scope': FilterViewScopeFromJSON(json['scope']),
        'view_key': json['view_key'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'filters': json['filters'],
        'is_default': json['is_default'] == null ? undefined : json['is_default'],
    };
}

export function CreateFilterViewRequestToJSON(json: any): CreateFilterViewRequest {
    return CreateFilterViewRequestToJSONTyped(json, false);
}

export function CreateFilterViewRequestToJSONTyped(value?: CreateFilterViewRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scope': FilterViewScopeToJSON(value['scope']),
        'view_key': value['view_key'],
        'name': value['name'],
        'description': value['description'],
        'filters': value['filters'],
        'is_default': value['is_default'],
    };
}

